export type ConfigType = 'llm' | 'vectorstore' | 'document' | 'embedding'
export type CloudProviderType = 'azure' | 'google' | 'openai' | 'perplexity' | 'ollama'
export type ModelProviderType = 'open_ai' | 'google' | 'perplexity' | 'anthropic'

// Valid combinations of cloud providers and model providers
export const LLM_PROVIDER_COMBINATIONS: Record<CloudProviderType, ModelProviderType[]> = {
    'azure': ['open_ai', 'anthropic'],
    'google': ['google', 'open_ai'],
    'openai': ['open_ai'],
    'perplexity': ['perplexity'],
    'ollama': ['open_ai'],
}

export type IModelPricing = {
    id?: number | null
    app_id: number
    name: string
    config_type: ConfigType
    version?: string | null
    calc_model_name?: string | null
    api_key?: string
    api_url?: string | null
    cloud_provider?: CloudProviderType | null
    model_provider?: ModelProviderType | null
    supported_tools?: string[] | null
    supported_mcp_servers?: string[] | null
    supports_responses?: boolean
    supports_reasoning?: boolean
    supports_thinking?: boolean
    supports_vision?: boolean
    supports_caching?: boolean
    supports_adaptive_thinking?: boolean
    has_api_key?: boolean
}
